import Cookies from 'js-cookie';
import { cookieConstants } from './constants';
var COOKIE_NAME = cookieConstants.COOKIE_NAME;
export var readClientCookie = function readClientCookie() {
  return Cookies.get(COOKIE_NAME);
};
export var writeClientCookie = function writeClientCookie(cookieValue, config) {
  return Cookies.set(COOKIE_NAME, cookieValue, config);
};